import { Log } from "oidc-client";
export const logger = (logger, level = 4) => {
    Log.logger = logger;
    Log.level = level;
};
//# sourceMappingURL=logger.js.map